<template>
  <div id="app">
      <div v-show="screenWidth>750" style="height: 120px"></div>
	<div class="header head" v-show="screenWidth>750">
        <div style="width: 1200px; margin: 0 auto">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" text-color="#000" active-text-color="#d19e11">
              <template v-for="item in links">
                  <template v-if="item.children&&item.children.length>0">
                        <el-submenu :index="item.index.toString()">
                          <template slot="title">{{item.name}}</template>
                          <template v-for="subItem in item.children">
                              <el-menu-item :index="subItem.index.toString()" @click="navTo(subItem.url)">{{subItem.name}}</el-menu-item>
                          </template>
                        </el-submenu>
                  </template>
                  <template v-else>
                        <el-menu-item :index="item.index.toString()" v-if="screenWidth>750||(screenWidth<751&&item.id!=1)" :class="item.id===1?'imgnavbox':''">
                            <div @click="navTo(item.url)">
                                <div v-if="item.id!=1">{{item.name}}</div>
                                <img v-else src="./assets/images/icon-02.png" />
                            </div>
                        </el-menu-item>
                  </template>
              </template>
            </el-menu>
        </div>
	</div>
	<div class="header hetopnav" v-show="screenWidth<751">
        <div class="clear">
            <img src="./assets/images/wap/waplogo.png" class="inline fll" @click="navTo('/')"/>
            <img src="./assets/images/wap/waphome.png" class="inline flr homebtn" @click="showNavMini"/>
        </div>
        <div class="navboxheader" v-show="minishow">

            <el-menu :default-active="activeIndex" class="el-menu-demo" @select="handleSelect" text-color="#bb8c22" active-text-color="#d19e11">
                <div @click="showNavMini" class="closenavminibtn"><i class="el-icon-circle-close"></i></div>
                <template v-for="item in links">
                    <template v-if="item.children&&item.children.length>0">
                        <el-submenu :index="item.index.toString()">
                            <template slot="title"  >{{item.name}}</template>
                            <template v-for="subItem in item.children">
                                <el-menu-item :index="subItem.index.toString()" @click="showNavMini"><a @click="navTo(subItem.url)" >{{subItem.name}}</a></el-menu-item>
                            </template>
                        </el-submenu>
                    </template>
                    <template v-else>
                        <el-menu-item :index="item.index.toString()" v-if="screenWidth<751"  @click="showNavMini">
                            <a @click="navTo(item.url)" >{{item.name}}</a>
                        </el-menu-item>
                    </template>
                </template>
            </el-menu>
        </div>
    </div>
    <router-view/>
	<div class="bottomcontent">
		<div class="center clear" v-if="screenWidth>750">
			<div class="inline width8" v-for="item in links" v-if="item.id != 1">
                <div class="botit" v-if="item.children&&item.children.length>0">{{item.name}}</div>
                <div class="botit" v-else="item.children&&item.children.length>0" @click="navTo(item.url)">{{item.name}}</div>
				<ul>
                    <li v-for="subItem in item.children"><a @click="navTo(subItem.url)">{{subItem.name}}</a></li>
				</ul>
			</div>
			<div class="inline flr wwimg">
				<img src="./assets/images/icon-05.png"/>
				<img src="./assets/images/icon-06.png"/>
			</div>
		</div>
		<div v-else>
			<el-menu :default-active="activeIndex" class="el-menu-demo bottomnavbox" :mode="screenWidth>750?'horizontal' : ''" @select="handleSelect" text-color="#fff" active-text-color="#d19e11">
			  <template v-for="item in links">
				  <template v-if="item.children&&item.children.length>0">
				  		<el-submenu :index="item.index.toString()">
				  		  <template slot="title">{{item.name}}</template>
				  		  <template v-for="subItem in item.children">
				  			  <el-menu-item :index="subItem.index.toString()" @click="navTo(subItem.url)">{{subItem.name}}</el-menu-item>
				  		  </template>
				  		</el-submenu>
				  </template>
				  <template v-else>
				  		<el-menu-item :index="item.index.toString()" v-if="screenWidth>750||(screenWidth<751&&item.id!=1)">
							<div @click="navTo(item.url)">
								<div v-if="item.id!=1">{{item.name}}</div>
								<img v-else src="./assets/images/icon-02.png" />
							</div>
						</el-menu-item>
				  </template>
			  </template>
			</el-menu>
		</div>
	</div>
	<div class="ub ub-ab ub-xc">
		<div class="linecenter footer">&copy;2020版权所有 {{siteInfo.company_name}} {{siteInfo.beian}} 使用条款</div>
		<div class="inline  wwimg ub ub-xc" v-if="screenWidth<751">
			<img src="./assets/images/wap/wb.png"/>
			<img src="./assets/images/wap/wx.png"/>
		</div>
	</div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
	  return {
		  screenWidth:document.body.clientWidth,
		  minishow:false,
		  screenHeight:'',
		  activeIndex:'1',
		  flag:0,
          siteInfo:[],
		  links:[
			  {
				  index:'1',
				  name:'',
				  children:[]
			  },
		  ]
	  }
  },
  watch:{
	screenWidth(){
		console.log(1111111111)
		this.flag++;
		if(this.flag>1){
			this,$router.go(0)
		}
	}
  },
  mounted() {
  	/* 窗口大小实时监听 */
	window.onresize = () => {
	    window.screenWidth = document.body.clientWidth;
	    this.screenWidth = window.screenWidth;
	};

  	// this.screenHeight = document.body.clientHeight;
	this.getData();
	},
  methods:{
	  showNavMini(){
		  this.minishow = !this.minishow
	  },
	  // 加载公共部分数据
	  getData: async function () {
		  const res = await this.$getJSON('/index/common', {});
		  this.siteInfo = res.data.siteInfo;
		  this.links = res.data.navList;
	  },
	  handleSelect(){

	  },
      navTo: function (url) {
          if(url === ""){
              return;
          } else if(url.substring(0, 1) == "/") {
              this.$router.push({path: url})
          } else {
              window.location.href = url;
          }
      }
  }
}
</script>

<style>
	.closenavminibtn,.closenavminibtn .el-icon-circle-close {
		width: 0.3rem;
		height: 0.3rem;
		text-align: right;
	}

.closenavminibtn .el-icon-circle-close:before{
	font-size: 0.2rem;
	    top: 0.06rem;
	    position: absolute;
	    right: 0.12rem;

}
.wwimg img{
	margin-right: 20px;
}
.wwimg{
	vertical-align: top;
}
.el-menu--horizontal>.el-menu-item.is-active{
	border-bottom: 0px!important;
}
.el-menu--horizontal>.el-menu-item{
	border-bottom: 0px;
}
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
  width: 100%;
}
.head{
    width: 100%;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    z-index: 99999999;
}
.header{

}
.el-submenu__icon-arrow{
	display: none;
}
.header .el-menu--horizontal>.el-submenu .el-submenu__title,
.header .el-menu--horizontal>.el-menu-item {
    height: 120px;
    line-height: 120px;
	font-size: 20px;
}
.el-menu--horizontal .el-menu .el-menu-item a:hover{
	color: #d19e12!important;
}
.header .el-menu--horizontal>.el-submenu .el-submenu__title:hover, .header .el-menu--horizontal>.el-menu-item:hover{
	color: #d19e12!important;
}
.el-menu.el-menu--horizontal{
	border: 0px!important;
}
.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
	font-size: 16px;
}
.el-menu--popup {
    min-width: 162px;
}
.el-menu--horizontal .el-menu .el-menu-item{
	padding: 0px 30px;
}
.header .el-submenu__title,.header .el-menu-item{
	padding: 0px 42px;

}

.header .el-menu--horizontal>.el-submenu .el-submenu__title, .header .el-menu--horizontal>.el-menu-item {
    height: 120px;
    line-height: 180px;
    font-size: 20px;
	border-bottom-color:#fff!important;
	border-bottom: 0px!important;
}
.header .el-menu--horizontal>.imgnavbox {
    height: 120px;
    line-height: 120px!important;

}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
	border-bottom: 0px!important;
}
.bottomcontent{
	background-color: #2f2d2d;
	color: #ffff;
	padding: 60px 0px;
	box-sizing: border-box;
}
.center{
	width: 1200px;
	margin: 0px auto;
	text-align: left;
}
.width8{
	width: 150px;
	vertical-align: top!important;
	color: #fff;
	text-align: center;
}
.width8 a{
	color: #fff;
	line-height: 38px;
  cursor:pointer

}
.botit{
	font-size: 20px;
	font-weight: bolder;
	line-height: 50px;
}
.footer{
	line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue